export default __webpack_public_path__ + "images/6c5d49c679ae35c60ad2a035492632d3-1_tablet_1067x470.jpg";